if (!customElements.get('cf-sprint-explainer')) {
  customElements.define('cf-sprint-explainer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.controls = [...this.querySelectorAll('[data-sprint-part]')];
      this.panels = [...this.querySelectorAll('[data-sprint-panel]')];
      this.addEventListener('click', event => {
        const control = event.target.closest('[data-sprint-part]');
        if (!control) return; event.preventDefault(); this.select(control.dataset.sprintPart);
      }, { signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        const labels = [...this.querySelectorAll('.cf-sprint-label')];
        const index = labels.indexOf(event.target);
        if (index < 0 || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? labels.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + labels.length) % labels.length;
        labels[next].focus(); this.select(labels[next].dataset.sprintPart);
      }, { signal: this.controller.signal });
      this.select(this.panels[0].dataset.sprintPanel); this.dataset.enhanced = '';
    }
    select(id) {
      this.controls.forEach(control => {
        const active = control.dataset.sprintPart === id;
        if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(active));
        else if (active) control.setAttribute('aria-current', 'true'); else control.removeAttribute('aria-current');
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.sprintPanel !== id; });
      this.querySelectorAll('[data-sprint-connector]').forEach(line => line.classList.toggle('is-active', line.dataset.sprintConnector === id));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
